module.exports = __webpack_public_path__ + "img/th.c0d9714c.jpg";